import { render, staticRenderFns } from "./LoadNotes.vue?vue&type=template&id=501f0adc"
import script from "./LoadNotes.vue?vue&type=script&lang=js"
export * from "./LoadNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports